"use client";

import { useState } from "react";

type ActionKey = "search" | "landing";

const actions: Record<ActionKey, { dot: string; title: string; detail: string; value: string; tag: string; evidence: string }> = {
  search: {
    dot: "coral",
    title: "Pause duplicate search term",
    detail: "Brand · exact match overlap",
    value: "+$4.2k",
    tag: "Review",
    evidence: "Overlap is diverting 18% of qualified clicks.",
  },
  landing: {
    dot: "gold",
    title: "Repair mobile landing page",
    detail: "Non-brand · high-intent traffic",
    value: "+$2.8k",
    tag: "Queued",
    evidence: "Slow load is suppressing conversion rate.",
  },
};

export function ActionPlan() {
  const [openRows, setOpenRows] = useState<Record<string, boolean>>({});

  const toggle = (key: string) => setOpenRows((state) => ({ ...state, [key]: !state[key] }));

  return (
    <div className="mini-app app-actions">
      <div className="mini-app-head">
        <div>
          <span className="mini-label">Action Plan · This week</span>
          <strong>Priority queue</strong>
        </div>
        <span className="mini-period">Updated 8m ago</span>
      </div>

      <div className="action-summary">
        <div>
          <strong>26</strong>
          <span>critical repairs</span>
        </div>
        <div>
          <strong>8</strong>
          <span>high impact</span>
        </div>
        <div>
          <strong>85%</strong>
          <span>confidence</span>
        </div>
      </div>

      <div className="action-group">
        <div className="group-head">
          <span>
            Eliminate waste <b>2</b>
          </span>
          <small>Potential lift</small>
        </div>
        {Object.entries(actions).map(([key, action]) => (
          <div key={key}>
            <button
              type="button"
              className={`action-row${openRows[key] ? " is-open" : ""}`}
              onClick={() => toggle(key)}
              aria-expanded={openRows[key]}
            >
              <span className={`action-dot ${action.dot}`} aria-hidden="true" />
              <span>
                <b>{action.title}</b>
                <small>{action.detail}</small>
              </span>
              <strong>
                {action.value} <i>{action.tag}</i>
              </strong>
            </button>
            {openRows[key] && (
              <div className="action-detail">
                <span>{action.evidence}</span>
                <button type="button">Open evidence ↗</button>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="action-foot">
        <span>Showing 2 of 8 recommendations</span>
        <button type="button">View all actions ↗</button>
      </div>
    </div>
  );
}